<script lang="ts">
    export let text = "";
    export let iconPath = "";
</script>

<div class="global-search__item-type">
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
    >
        {@html iconPath}
    </svg>

    <span>{text}</span>

    <slot />
</div>

<style>
    .global-search__item-type {
        @apply sticky top-0 flex cursor-default flex-row gap-2 rounded-sm bg-gray-200 px-2 py-2 text-xs text-gray-600 shadow-sm;
    }

    .global-search__item-type svg {
        @apply h-4 w-4;
    }
</style>
